var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrowDow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8281 7.64844L15 8.82031L10 13.8203L5 8.82031L6.17188 7.64844L10 11.4766L13.8281 7.64844Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowDow);
export default __webpack_public_path__ + "static/media/SelectArrowDow.54156d7285c0da118100effaa4515384.svg";
export { ForwardRef as ReactComponent };